import { useState, useEffect, useRef } from "react";
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '@/app/style/photos.scss';
import PhotoCaption from "./photoCaption";
import styled from "styled-components";
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';


interface PhotoType {
  photo: string;
  title: string;
  content: string;
  width: number;
  height: number;
}

const PhotoContainer = styled.div`
  height: 515px;
  width: 100%;
  background-color: #333333;
  overflow: hidden;
`;

const PhotoDiv = styled.div`
  height: 435px;
  width: 100%;
  background-color: #333333;
  position: relative;
}
`;

const PhotoZoomContainer = styled.div`
  bottom: 0px;
  position: absolute;
  z-index: 98;
  width: calc(100% - 88px);
  background-color: #333333;
  border-radius: 4px;
`;
const PhotoZoom = styled.div`
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #212121;
  overflow: hidden;
  border-radius: 8px;
  margin: 12px 14px;
`;

const ZoomBtn=styled(Button)`
    background-color: #212121;
    border-radius: 0;
    height: 24px;
    min-width:24px;
    width:24px;
    margin:0 8px;
    box-shadow:none!important;
    &:hover{
        background-color: #212121;
    }
    &:focus{
        boxShadow: 0 0 0 0.2rem rgba(0,123,255,.5)
    }

    &.Mui-disabled{
      opacity: 0.4;
      background-color: #212121;
      color: white;
  }
`
const ZoomSlider=styled(Slider)`
    padding: 2px 0;
    width: 168px;
    border-radius: 8px;
    & .MuiSlider-track{
        background-color:white;
        border: 1px solid white;
    }
    & .airbnb-bar{
        background-color:white;
    }
    & .MuiSlider-rail{
        background-color:white;
    }
    & .MuiSlider-thumb{
        background-color:#fff;
        height: 10px;
        width: 10px;
        &:before{
            box-shadow:none!important;
        }
        &:hover{
            box-shadow:none!important;
        } 
        &:after{
            box-shadow:none!important;
            height:0px;
            width:0px;
        }
    }
    &:focus{
        box-shadow:none!important;
    }
    &:hover{
        box-shadow:none!important;
    } 
    &:before{
        box-shadow:none!important;
    }
    & .Mui-active{
        box-shadow:none!important;
    }
`

const Photos = (props: any)=>{
  const isMobile = props?.type=="mobile";

  const [photosArr, setPhotosArr] = useState<PhotoType[]>([])
  const [pageWidth, setPageWidth] = useState(0);

  useEffect(() => { 
    const photoList : PhotoType[] = []
    const multiplePhoto = props?.data;

    console.log("photo_data",multiplePhoto);

    multiplePhoto?.map((item:any) => {
      if (item.photo?.src) {
        let pInfo: PhotoType = {
          //photo: "/raceInfo.png",
          photo: item.photo?.src,
          title: item.captionTitle?.value,
          content: item.captionContent?.value,
          width: item.photo?.width,
          height: item.photo?.height
        };

        photoList.push(pInfo)
      }
    })

    
    console.log("photo_List",photoList);
    setPhotosArr(photoList);
    setPageWidth(window.innerWidth);

    const handleWindowResize = () => setPageWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);

  }, [props?.data]);
  
  const canShow=photosArr?.length>0

  let slidesView = 0;
  if(isMobile)
  {
    let preView = (pageWidth  - 24)/68; 
    slidesView = photosArr?.length < preView ? preView : Math.floor(preView);
  }else{
    let preView = ((pageWidth>1808 ? 1808 : pageWidth)  - 228 - 136)/132;
    slidesView = photosArr?.length < preView ? preView : Math.floor(preView);
  }


  return(
    canShow&&<div className="photos-swiper-container">
        <Photo photosArr={photosArr} slidesView={slidesView} isDesktop={!isMobile}/>    
    </div>
  )
}


const Photo = (props: any) => {
  const refDivPhoto = useRef(null);
  const refDivCaption = useRef(null);
  const {photosArr,slidesView, isDesktop} = props
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [sliderValue,setSliderValue]=useState(100);

  const [divWidth, setDivWidth] = useState(1476);
  const divHeight = 435;

  const imgOriginalWidth = photosArr[0]?.width;
  const imgOriginalHeight = photosArr[0]?.height;


  const [sliderIndex,setSliderIndex]=useState(0);

  const [imgWidth, setImgWidth] = useState(imgOriginalWidth);
  const [imgHeight, setImgHeight] = useState(imgOriginalHeight);


  useEffect(() => {  
    const handleWindowResize = () => 
    {
      if ((refDivPhoto as any)?.current) {
        const dWidth = (refDivPhoto as any)?.current?.offsetWidth;   
        if(dWidth && dWidth-88 > 0)
        {
          const divPhotoWidth = dWidth-88;
          setDivWidth(divPhotoWidth);
          const imgOriginalWidthIndex = photosArr[sliderIndex]?.width;
          const imgOriginalHeightIndex = photosArr[sliderIndex]?.height;
          console.log(sliderIndex,divPhotoWidth,imgOriginalWidthIndex,imgOriginalHeightIndex, 'dWidthoffsetWidth');
          if(imgOriginalWidthIndex>divPhotoWidth || imgOriginalHeightIndex>divHeight)
          {
            const factor = calculateScaleFactor(imgOriginalWidthIndex,imgOriginalHeightIndex,divPhotoWidth,divHeight);
            setImgWidth(imgOriginalWidthIndex * factor);
            setImgHeight(imgOriginalHeightIndex * factor);

            console.log(factor, 'factor');
          }else{
            setImgWidth(imgOriginalWidthIndex);
            setImgHeight(imgOriginalHeightIndex);
          }
        }
      }
    }
    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  });

useEffect(() => {  
  var divPhoto = document.getElementById("divPhoto_"+sliderIndex);
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          var divCaption = document.getElementById("divCaption_"+sliderIndex);
          if(divCaption)
          {
            const divElement = divPhoto as HTMLDivElement;
            const hasVerticalScrollbar = divElement.scrollHeight - divElement.clientHeight > 15;
            const hasHorizontalScrollbar = divElement.scrollWidth - divElement.clientWidth > 15;
            if(hasVerticalScrollbar)
            {
              divCaption.style.width = "calc(100% - 15px)";
            }else{
              divCaption.style.width = "100%";
            }
            if(hasHorizontalScrollbar)
            {
              divCaption.style.bottom = "95px";
            }else{
              divCaption.style.bottom = "80px";
            } 
          }
          
        }
    });
  });

  if(hasBrowserScrollbar() && divPhoto)
  {
    observer.observe(divPhoto, { attributes: true, childList: true, subtree: true });
  }
}, [sliderIndex]);
  

  const calculateScaleFactor = (originalWidth:any,originalHeight:any, targetWidth:any,targetHeight:any) => {
    const widthRatio = targetWidth / originalWidth;
    const heightRatio = targetHeight / originalHeight;
    const newScaleFactor = Math.min(widthRatio, heightRatio);
    return newScaleFactor;
  };

  const hasBrowserScrollbar = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/safari/i) && !ua.match(/chrome/i)) {
      return false;
    } else {
      return true;
    }
  }

  const onThumbsSwiper = (swiper: any) => 
    {
      setThumbsSwiper(swiper)
    };

  const onSlideChange= (e:any) => 
    {
      if(isDesktop)
      {
        const sIndex = e.activeIndex;
        setSliderIndex(sIndex);
        setImgWidth(photosArr[sIndex]?.width);
        setImgHeight(photosArr[sIndex]?.height);
        setSliderValue(100);
      }
      
      (refDivCaption.current as any)?.OnBackToCollapsed()
    };

  const navigation={
    prevEl: '.thumbs-navigation-prev',
    nextEl: '.thumbs-navigation-next',
    clickable:true
  }

  const handleSliderChange = (value: number) => {  
    setSliderValue(value);
  };

  const handleScale=(flag:string)=>{
    if(flag=='+'){
      setSliderValue(sliderValue+50);
    }
    else if(flag=='-'){
      setSliderValue(sliderValue-50);
    }
  }

  return (
    <>
      <div className="photos-and-caption" ref={refDivPhoto} >
        <Swiper 
          loop={false}
          onSlideChange={onSlideChange}
          spaceBetween={0}
          navigation={true}
          allowTouchMove={!isDesktop}
          thumbs={{ swiper: thumbsSwiper }}
          modules={[FreeMode, Navigation, Thumbs]}
          className="photos-swiper-main"
        >
          {photosArr.map((photoItem:any,index:number)=>{
              return(
                <SwiperSlide key={index}> 
                  { isDesktop ? 
                    <PhotoContainer>
                      <div>
                        <PhotoDiv id={`divPhoto_${index}`} style={{paddingTop:`${divHeight - imgHeight*sliderValue/100>0 ? (divHeight - imgHeight*sliderValue/100)/2 : 0}px`, paddingLeft:`${divWidth - imgWidth*sliderValue/100>0?(divWidth - imgWidth*sliderValue/100)/2 : 0}px`, overflow: `${sliderValue == 100  ? 'hidden' : 'auto'}` }}>
                          <img style={{'width':`${imgWidth * sliderValue/100}px`, 'height':`${imgHeight * sliderValue/100}px`, 'max-width':`${sliderValue == 100  ? '100%' : 'inherit'}`, 'max-height':`${sliderValue == 100  ? '100%' : 'inherit'}`} as React.CSSProperties} src={photoItem.photo}></img>
                        </PhotoDiv>
                        <div id={`divCaption_${index}`} style={{position: "absolute", bottom: "80px", width: "calc(100% - 0px)"}}>
                          <PhotoCaption title={photoItem.title} content={photoItem.content} childRef={refDivCaption} isDesktop={true} index={index}></PhotoCaption>
                        </div>
                      </div>  
                    </PhotoContainer> 
                  :<>
                    <img src={photoItem.photo}/>
                    <PhotoCaption title={photoItem.title} isDesktop={isDesktop} content={photoItem.content} childRef={refDivCaption} index={index}></PhotoCaption>
                    </>
                  }
                </SwiperSlide>
              )
            })
          }
          {isDesktop ? <PhotoZoomContainer><PhotoZoom>
                <ZoomBtn variant="contained" size="small" disabled={sliderValue==100} onClick={()=>handleScale('-')}>
                    <HorizontalRuleOutlinedIcon />
                </ZoomBtn>
                <ZoomSlider
                    onChangeCommitted={(event: React.SyntheticEvent | Event, value: number | Array<number>)=>{handleSliderChange(value as number)}}
                    step={50}
                    min={100}
                    max={300}
                    value={sliderValue}
                />
                <ZoomBtn variant="contained" size="small"  disabled={sliderValue==300} onClick={()=>handleScale('+')}>
                    <AddOutlinedIcon />
                </ZoomBtn>
            </PhotoZoom></PhotoZoomContainer> : <></> 
          }              
        </Swiper>
      </div>
      {
        isDesktop? <div className="thumbs-and-navigation">
          <div className="thumbs-navigation-prev"></div>
          <Swiper
            onSwiper={onThumbsSwiper}       
            loop={false}
            navigation={isDesktop?navigation:false}
            spaceBetween={12}
            slidesPerView={slidesView}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            className="photos-swiper-thumbs"
          >
          {photosArr.map((photoItem:any,index:number)=>{
                return(
                  <SwiperSlide key={index}> 
                    <img src={photoItem.photo}/>
                  </SwiperSlide>
                )
              })
            }
          </Swiper>
          <div className="thumbs-navigation-next"></div>
        </div> 
      : <Swiper
          onSwiper={onThumbsSwiper}       
          loop={false}
          navigation={isDesktop?navigation:false}
          spaceBetween={12}
          slidesPerView={slidesView}
          freeMode={true}
          watchSlidesProgress={true}
          modules={[FreeMode, Navigation, Thumbs]}
          className="photos-swiper-thumbs"
        >
        {photosArr.map((photoItem:any,index:number)=>{
              return(
                <SwiperSlide key={index}> 
                  <img src={photoItem.photo}/>
                </SwiperSlide>
              )
            })
          }
        </Swiper>
      }
      
  </>
  );  
}

export default Photos